<template>
  <div>
    <div class="row">
      <div class="col-lg-3">
        <label>Title</label>
        <input type="text" class="form-control" v-model="filters.title" @keydown.enter="taskStore.updateFilters('title', $event.target.value)">
      </div>
      <div class="col-lg-3">
        <label>Status</label>
        <v-select :options="statuses" label="label" index="index" v-model="filters.status" @change="taskStore.updateFilters('status', $event)" multiple="multiple"></v-select>
      </div>
      <div class="col-lg-3">
        <label>Priority</label>
        <v-select :options="priorities" label="label" index="index" v-model="filters.priority" @change="taskStore.updateFilters('priority', $event)" multiple="multiple"></v-select>
      </div>
      <div class="col-lg-3">
        <label>Due Date</label>
        <input type="date" v-model="filters.dueDate" min="0" class="pretty-input form-control" @change="taskStore.updateFilters('dueDate', $event)">
      </div>
    </div>
    <div>
    </div>
    <div class="row m-t-xs">
      <div class="col-lg-3">
        <label>Assigned To</label>
        <v-select multiple="multiple" :options="users" label="username" index="id" v-model="filters.assignee" @change="taskStore.updateFilters('assignee', $event)"></v-select>
      </div>
      <div class="col-lg-3">
        <label>Created By</label>
        <v-select :options="users" label="username" index="id" v-model="filters.creator" @change="taskStore.updateFilters('creator', $event)" multiple="multiple"></v-select>
      </div>
      <div v-if="!project" class="col-lg-3">
        <label>Client</label>
        <v-select :options="f.clients" label="name" index="id" v-model="filters.client" @change="taskStore.updateFilters('client', $event)"></v-select>
      </div>
      <div v-if="!project" class="col-lg-3">
        <label>Project</label>
        <v-select :options="projects" label="name" index="id" v-model="filters.project" @change="taskStore.updateFilters('project', $event)"></v-select>
      </div>
    </div>
  </div>
</template>
<script>
import { storeToRefs } from 'pinia'
import { mapGetters } from 'vuex'
import { useProjectStore } from '../../../../stores/ProjectStore'
import { useTaskStore } from '../../../../stores/TaskStore'

export default {
  setup () {
    const taskStore = useTaskStore()
    const statuses = taskStore.taskStatuses
    const priorities = taskStore.taskPriorities
    const filters = {...taskStore.filters}

    const projectStore = useProjectStore()
    const { projects } = storeToRefs(projectStore)
    if (!projects.length) projectStore.loadProjects()

    return { taskStore, statuses, priorities, projects, filters }
  },
  props: {
    project: { default: null },
    listView: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      f: 'getFilters'
    })
  },
  created () {
    if (this.project) {
      this.taskStore.updateFilters('project', this.project.id)
    }

    if (this.listView) {
      this.taskStore.updateFilters('project', null)
      delete this.filters.project
    }

    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Filters.vue